import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
var _CloseIcon, _ListItemIcon;
/* eslint-disable max-lines */

import React, { useRef, useState, useEffect } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import MenuList from '@mui/material/MenuList';
import Typography from '@mui/material/Typography';
import ListItemIcon from '@mui/material/ListItemIcon';
import { SideNavButton } from './internal/SideNavButton';
import { SideNavPopover } from './internal/SideNavPopover';
import { Help } from '../icons/Help';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useLocalization, useTranslate } from '@im/react-localization';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var HELP = 'help';
var LEFT_SIDE_NAV = 'left-side-nav';
export function LeftSideNavMobile(props) {
  var activeSideNavItem = props.activeSideNavItem,
    _props$headerHeight = props.headerHeight,
    headerHeight = _props$headerHeight === void 0 ? 100 : _props$headerHeight,
    helpNavItems = props.helpNavItems,
    hoverRequired = props.hoverRequired,
    isHelpNavItemVisible = props.isHelpNavItemVisible,
    navActionItem = props.navActionItem,
    navItems = props.navItems,
    onClose = props.onClose,
    onNavItemClickProp = props.onNavItemClick,
    setActiveSideNavItem = props.setActiveSideNavItem,
    sx = props.sx;
  var _useLocalization = useLocalization(),
    translate = _useLocalization.translate;
  var ariaLabelTranslate = useTranslate();
  var theme = useTheme();
  var menuItem = {
    key: LEFT_SIDE_NAV
  };
  var helpNavItem = {
    key: HELP,
    label: "".concat(ariaLabelTranslate('Common.Help')),
    navItems: helpNavItems
  };
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    openItems = _useState2[0],
    setOpenItems = _useState2[1];
  var _useState3 = useState(activeSideNavItem),
    _useState4 = _slicedToArray(_useState3, 2),
    activeTopItem = _useState4[0],
    setActiveTopItem = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    hoveredItem = _useState6[0],
    setHoveredItem = _useState6[1];
  var stackRef = useRef(null);
  useEffect(function () {
    setActiveTopItem(activeSideNavItem);
  }, [activeSideNavItem]);
  var onNavItemClick = function onNavItemClick(navItem, level, event) {
    if (navItem.key === HELP) {
      setActiveTopItem(navItem);
      setOpenItems([navItem]);
    } else {
      var _openItems$;
      if (level === 0) {
        setActiveTopItem(navItem);
      }
      if ((openItems == null ? void 0 : (_openItems$ = openItems[0]) == null ? void 0 : _openItems$.key) === (navItem == null ? void 0 : navItem.key)) {
        setActiveTopItem(undefined);
        setOpenItems([]);
      } else if (!navItem.navItems && (navItem.route || navItem.url)) {
        setActiveSideNavItem(level === 0 ? navItem : activeTopItem);
        onNavItemClickProp(navItem);
        setOpenItems([]);
        setHoveredItem(null);
      } else {
        setOpenItems([navItem]);
      }
    }
  };
  var onNavItemHover = function onNavItemHover(navItem, level) {
    var newOpenItems = _toConsumableArray(openItems);
    newOpenItems.length = level;
    if (navItem.navItems) {
      newOpenItems.push(navItem);
    }
    setOpenItems(newOpenItems);
    setTimeout(function () {
      setOpenItems(_toConsumableArray(newOpenItems));
    }, 1);
  };
  var onNavItemBack = function onNavItemBack() {
    var newOpenItems = _toConsumableArray(openItems);
    newOpenItems.pop();
    setOpenItems(_toConsumableArray(newOpenItems));
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(MenuHeader, {
      direction: "row",
      "data-element": "MenuHeader",
      "data-source-file": "LeftSideNavMobile.tsx",
      children: [/*#__PURE__*/_jsx(Typography, {
        sx: {
          color: "".concat(theme.palette.grey[700]),
          fontSize: '16px'
        },
        variant: "bodycopysemibold",
        "data-element": "Typography",
        "data-source-file": "LeftSideNavMobile.tsx",
        children: translate('Common.Menu')
      }), /*#__PURE__*/_jsx(IconButton, {
        "aria-label": ariaLabelTranslate('Checkout.close'),
        onClick: onClose,
        sx: {
          height: '32px',
          width: '32px'
        },
        "data-element": "IconButton",
        "data-source-file": "LeftSideNavMobile.tsx",
        children: _CloseIcon || (_CloseIcon = /*#__PURE__*/_jsx(CloseIcon, {
          "data-element": "CloseIcon",
          "data-source-file": "LeftSideNavMobile.tsx"
        }))
      })]
    }), /*#__PURE__*/_jsxs(SytledMenuList, {
      "aria-busy": "true",
      className: "sidenav-base-menulist",
      disablePadding: true,
      isHover: true,
      onMouseEnter: function onMouseEnter() {
        if (!hoveredItem && hoverRequired) {
          setHoveredItem(menuItem);
        }
      },
      onMouseLeave: function onMouseLeave() {
        if ((!openItems || (openItems == null ? void 0 : openItems.length) === 0) && hoverRequired) {
          setHoveredItem(null);
        }
      },
      onMouseOver: function onMouseOver() {
        if (!hoveredItem && hoverRequired) {
          setHoveredItem(menuItem);
        }
      },
      ref: stackRef,
      sx: sx,
      "data-element": "SytledMenuList",
      "data-source-file": "LeftSideNavMobile.tsx",
      children: [navItems.map(function (navItem) {
        var _navItem$navItems;
        var isOpen = navItem === openItems[0];
        var isActive = navItem.key === (activeTopItem == null ? void 0 : activeTopItem.key);
        return /*#__PURE__*/_jsx(SideNavButton, {
          active: isActive,
          "data-testid": "".concat(navItem.key, "-MenuItem"),
          hasItems: !!navItem.navItems && ((_navItem$navItems = navItem.navItems) == null ? void 0 : _navItem$navItems.length) > 0,
          hoveredItem: hoveredItem,
          isOpen: isOpen || isActive,
          navItem: navItem,
          onClick: function onClick(e) {
            return onNavItemClick(navItem, 0, e);
          },
          children: navItem.label || navItem.key
        }, navItem.key);
      }), navActionItem && /*#__PURE__*/_jsx(Button, {
        "aria-label": navActionItem.title,
        "data-name": navActionItem.trackingTag,
        onClick: navActionItem.onClick,
        sx: {
          mb: '40px',
          mt: '8px',
          width: '100%'
        },
        variant: "newContained",
        children: /*#__PURE__*/_jsx(Typography, {
          sx: {
            lineHeight: '22px'
          },
          variant: "body2",
          children: navActionItem.title
        })
      }), isHelpNavItemVisible && /*#__PURE__*/_jsxs(HelpMenu, {
        isActive: (activeTopItem == null ? void 0 : activeTopItem.key) === HELP,
        isHover: true,
        onClick: function onClick(e) {
          return onNavItemClick(helpNavItem, 0, e);
        },
        children: [_ListItemIcon || (_ListItemIcon = /*#__PURE__*/_jsx(ListItemIcon, {
          children: /*#__PURE__*/_jsx(Help, {})
        })), /*#__PURE__*/_jsx(Typography, {
          children: translate('Common.Help')
        }), ' ', /*#__PURE__*/_jsx(StyledListItemIcon, {
          children: /*#__PURE__*/_jsx(ArrowForwardIosIcon, {
            sx: {
              height: '12px !important',
              width: '12px !important'
            }
          })
        })]
      })]
    }), /*#__PURE__*/_jsx(SideNavPopover, {
      headerHeight: headerHeight,
      onClose: onClose,
      onNavItemBack: onNavItemBack,
      onNavItemClick: onNavItemClick,
      onNavItemHover: onNavItemHover,
      open: Boolean(openItems.length),
      openItems: openItems,
      "data-element": "SideNavPopover",
      "data-source-file": "LeftSideNavMobile.tsx"
    })]
  });
}
var StyledListItemIcon = styled(ListItemIcon)(function (_ref) {
  var theme = _ref.theme;
  return {
    color: theme.palette.grey[600],
    justifyContent: 'center',
    marginRight: '0 !important'
  };
});
var MenuHeader = styled(Stack)(function (_ref2) {
  var theme = _ref2.theme;
  return {
    alignItems: 'center',
    borderBottom: "1px solid ".concat(theme.palette.grey[200]),
    height: '52px',
    justifyContent: 'space-between',
    padding: '6px 16px',
    width: '100%'
  };
});
var SytledMenuList = styled(MenuList, {
  shouldForwardProp: function shouldForwardProp(props) {
    return props !== 'isHover';
  }
})(function (_ref3) {
  var isHover = _ref3.isHover,
    theme = _ref3.theme;
  return {
    '& div.MuiListItemButton-root': {
      '&.active': {
        '&:hover': {
          '& > *': {
            backgroundColor: "".concat(theme.palette.primary[50], " !important")
          }
        },
        '&:not(:first-of-type)': {
          '& svg > path': {
            '&:not(:last-child)': {
              fill: theme.palette.primary[900]
            }
          }
        },
        backgroundColor: "".concat(theme.palette.primary[50], " !important")
      },
      '&:first-of-type': {
        '&:hover': {
          '& > *': {
            backgroundColor: theme.palette.grey[50]
          },
          backgroundColor: theme.palette.grey[50]
        }
      },
      '&:not(:first-of-type)': {
        '&:hover': {
          '& > *': {
            backgroundColor: theme.palette.grey[50]
          },
          '& svg > path': {
            '&:first-of-type': {
              fill: theme.palette.primary[900]
            },
            '&:not(:last-child)': {
              fill: theme.palette.primary[900]
            }
          },
          backgroundColor: theme.palette.grey[50]
        }
      }
    },
    alignItems: 'center',
    backgroundColor: theme.palette.common.white,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: '8px',
    width: '100vw'
  };
});
var HelpMenu = styled(Box, {
  shouldForwardProp: function shouldForwardProp(props) {
    return props !== 'isHover' && props !== 'isVisible' && props !== 'isActive';
  }
})(function (_ref4) {
  var _ref4$isActive = _ref4.isActive,
    isActive = _ref4$isActive === void 0 ? false : _ref4$isActive,
    _ref4$isHover = _ref4.isHover,
    isHover = _ref4$isHover === void 0 ? false : _ref4$isHover,
    theme = _ref4.theme;
  return {
    '& .MuiListItemIcon-root': {
      '& .MuiSvgIcon-root': {
        '& svg > path': {
          fill: isActive ? theme.palette.primary[900] : theme.palette.grey[600]
        },
        height: 24,
        width: 24
      },
      alignItems: '',
      backgroundColor: isActive ? theme.palette.primary[50] : 'transparent',
      border: 'none',
      borderRadius: 4,
      color: isActive ? theme.palette.primary[900] : theme.palette.grey[600],
      display: 'flex',
      flexDirection: 'row',
      // height: 48,
      margin: '0 8px',
      minWidth: 24
    },
    '& .MuiTypography-root': {
      color: isActive ? theme.palette.primary[900] : theme.palette.grey[600],
      display: isHover ? 'block' : 'none',
      fontSize: '14px',
      textAlign: 'left',
      width: '100%'
    },
    '&:hover': {
      '& .MuiListItemIcon-root': {
        '&:first-of-type': {
          '& svg > path': {
            fill: theme.palette.primary[900]
          }
        },
        backgroundColor: isActive ? theme.palette.primary[50] : theme.palette.grey[50]
      },
      '& .MuiTypography-root': {
        color: theme.palette.primary[900],
        fontSize: '14px'
      },
      backgroundColor: isActive ? theme.palette.primary[50] : theme.palette.grey[50]
    },
    alignItems: 'center',
    backgroundColor: isActive ? theme.palette.primary[50] : 'transparent',
    bottom: 8,
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'flex-start',
    margin: '0 4px',
    padding: 12,
    position: 'absolute',
    width: '100%'
  };
});